import { nanoid } from 'nanoid';

export const newUTM = () => {
  return {
    id: nanoid(),
    user: '',
    dateCreated: Date.now(),
    organization: 'User Org',
    groupName: '',
    destinationUrl: '',
    campaign: '',
    jobName: '',
    medium: '',
    source: '',
    content: '',
    keyword: '',
    utm: ''
  };
};

export const validURL = (str) => {
  const pattern = new RegExp(
    '^(http|https)://' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-zd/#(d+)/]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i'
  ); // fragment locator
  return !!pattern.test(str) && percURLCheck(str);
};

// Check for propane.com or training.propane.com in URL
export const percURLCheck = (str) =>
  str.includes('training.propane.com') || str.includes('propane.com');

export const convertTimestamp = (timestamp) => {
  const unformattedDate = new Date(timestamp);
  let formattedString = '';

  if (unformattedDate.getMonth() < 9) {
    formattedString += '0';
  }

  formattedString += unformattedDate.getMonth() + 1;

  if (unformattedDate.getDate() < 10) {
    formattedString += '0';
  }

  formattedString += unformattedDate.getDate();
  formattedString += unformattedDate.getFullYear();

  return formattedString;
};

export const validCampaign = (campaign) => (campaign.length > 0 ? true : false);
export const validMedium = (medium) => (medium.length > 0 ? true : false);
export const validSource = (source) => (source.length > 0 ? true : false);

export const formatParam = (str) => {
  return str
    .toLowerCase()
    .replace(/\\|\//g, '')
    .replace(/\s+/g, '-') //replace spaces with dashes
    .replace(/\s/g, '');
};

export const addTrailingSlash = (url) => url.replace(/\/?$/, '/');
